"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _memberManagement = require("@/api/member/memberManagement");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MemberAddress',
  props: {
    memberData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    // 获取用户地址列表
    fetchUserAddresses: function () {
      var _fetchUserAddresses = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              params = {
                page: this.currentPage,
                // 当前页码
                limit: this.pageSize,
                // 每页条数
                userId: this.memberData.id || this.memberData.userId // 根据会员ID获取地址
              };
              _context.next = 2;
              return (0, _memberManagement.xyUserAddressPage)(params);
            case 2:
              response = _context.sent;
              if (response.code === 200) {
                this.tableData = response.records || [];
                this.total = response.total || 0;
              } else {
                this.$message.error(response.message || '获取用户地址失败');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              console.error('获取用户地址失败:', _t);
              this.$message.error('获取用户地址失败');
            case 4:
              _context.prev = 4;
              this.loading = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function fetchUserAddresses() {
        return _fetchUserAddresses.apply(this, arguments);
      }
      return fetchUserAddresses;
    }(),
    // 导出会员地址
    handleExportAddress: function () {
      var _handleExportAddress = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              this.$message.info('正在导出会员地址数据...');
              params = {
                userId: this.memberData.id || this.memberData.userId // 根据会员ID导出地址
              };
              _context2.next = 1;
              return (0, _memberManagement.exportUserAddresses)(params);
            case 1:
              response = _context2.sent;
              // 根据后端接口规范，成功时返回CommonResponse("数据导出中，请稍后查看")
              if (response && response.code === 0) {
                this.$message.success('数据导出中，请稍后查看');
              } else {
                this.$message.error(response.message || '导出失败');
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('导出失败:', _t2);
              this.$message.error('导出失败：' + (_t2.message || '网络异常'));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function handleExportAddress() {
        return _handleExportAddress.apply(this, arguments);
      }
      return handleExportAddress;
    }(),
    // 移除地址
    handleDelete: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(row) {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$confirm("\u786E\u8BA4\u79FB\u9664\u6536\u8D27\u4EBA ".concat(row.consignee, " \u7684\u5730\u5740?"), '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var addressId, _t3;
                return regeneratorRuntime.wrap(function (_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.prev = 0;
                      // 调用删除API，传递addressId参数
                      addressId = row.id;
                      _context3.next = 1;
                      return (0, _memberManagement.deleteXyUserAddress)(addressId);
                    case 1:
                      _this.$message.success('移除成功');
                      _this.fetchUserAddresses(); // 重新获取数据
                      _context3.next = 3;
                      break;
                    case 2:
                      _context3.prev = 2;
                      _t3 = _context3["catch"](0);
                      console.error('删除地址失败:', _t3);
                      _this.$message.error('删除失败：' + (_t3.message || '未知错误'));
                    case 3:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3, null, [[0, 2]]);
              }))).catch(function () {
                _this.$message.info('已取消移除');
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleDelete(_x) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }(),
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchUserAddresses();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchUserAddresses();
    },
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return '';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    // 获取完整地址
    getFullAddress: function getFullAddress(row) {
      var parts = [row.countryName, row.provinceName, row.cityName, row.districtName, row.address].filter(function (part) {
        return part && part.trim();
      });
      return parts.join(' ');
    }
  },
  mounted: function mounted() {
    // 初始化时获取用户地址数据
    this.fetchUserAddresses();
  }
};